module.exports = __webpack_public_path__ + "img/aliceblue-logo.537c5c6b.png";